module.exports = __webpack_public_path__ + "static/media/msnstart_120.4050c88b.ico";